document.addEventListener('DOMContentLoaded', function() {
  var MOBILE_BREAKPOINT = 769;

  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  function destroySwiper(swiperEl) {
    if (swiperEl.swiper) {
      try { swiperEl.swiper.destroy(true, true); } catch(e) {}
    }
  }

  function initCategorySwipers() {
    var swipers = document.querySelectorAll('.coffee-needs-swiper');
    swipers.forEach(function(swiperEl) {
      var slidesCount = swiperEl.querySelectorAll('.coffee-card-slide').length;

      // On mobile, destroy any existing swiper and let CSS grid take over
      if (isMobile()) {
        destroySwiper(swiperEl);
        // Remove swiper-initialized class so CSS fallback/grid styles apply
        swiperEl.classList.remove('swiper-initialized');
        return;
      }

      // Desktop: initialize or re-initialize Swiper
      if (typeof Swiper !== 'undefined') {
        destroySwiper(swiperEl);
        var centerSlides = swiperEl.getAttribute('data-center') !== 'false';
        
        var desktopSlidesPerView = slidesCount > 4 ? 4 : slidesCount;
        var tabletSlidesPerView = slidesCount > 3 ? 3 : slidesCount;

        new Swiper(swiperEl, {
          slidesPerView: tabletSlidesPerView,
          spaceBetween: 20,
          grabCursor: true,
          centerInsufficientSlides: centerSlides,
          breakpoints: {
            769:  { slidesPerView: tabletSlidesPerView, spaceBetween: 20 },
            1024: { slidesPerView: desktopSlidesPerView, spaceBetween: 32 }
          }
        });
      }
    });
  }

  // Initialize the native fallback immediately; enhance it if Swiper is available.
  initCategorySwipers();

  window.addEventListener('load', function() {
    initCategorySwipers();
  });

  // Polling fallback for deferred Swiper loading
  var count = 0;
  var timer = setInterval(function() {
    count++;
    if (typeof Swiper !== 'undefined') {
      initCategorySwipers();
      clearInterval(timer);
    } else if (count > 100) {
      clearInterval(timer);
    }
  }, 50);

  // Re-evaluate on resize (debounced)
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initCategorySwipers, 150);
  });

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.querySelector('.coffee-needs-swiper')) {
      setTimeout(initCategorySwipers, 100);
    }
  });
});
